import { ISelectItem } from '@lla-platform/core/core-ui'

export enum GoogleAdsChargeType {
  Unknown = 'Unknown',
  Charged = 'Charged',
  InReview = 'InReview',
  Credited = 'Credited',
  NotCharged = 'NotCharged'
}

export const GoogleAdsChargeTypeToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  Charged: 'Charged',
  InReview: 'In Review',
  Credited: 'Credited',
  NotCharged: 'Not Charged'
}

export const GoogleAdsChargeTypeItems: ISelectItem[] = Object.values(GoogleAdsChargeType).map(
  (value) => ({
    label: GoogleAdsChargeTypeToLabel[value],
    value
  })
)
